/**
 * CanvasContext — 演画设计器全局 Context 入口
 *
 * 状态由 Zustand store（../store/canvas.store.ts）管理，此文件只提供
 * React 友好的 `CanvasProvider` 和 `useCanvas` API。
 *
 * 性能敏感组件请改用细粒度 hooks：
 *   import { useViewport, useSelection, useHistoryState } from '../store';
 */

import React from 'react';
import { useCanvasStore } from '@/components/canvas/store/canvas.store';
import type { CanvasContextValue } from '@/components/canvas/store/canvas.store';

export type { CanvasState, CanvasActions, CanvasContextValue } from '@/components/canvas/store/canvas.store';

/**
 * CanvasProvider — 无需任何操作，Zustand store 不依赖 React Context Provider。
 */
export function CanvasProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

/**
 * useCanvas — 订阅完整 Store。
 * 注意：任何状态变化都会触发重渲染；性能敏感场景请用 store/hooks.ts 细粒度 hooks。
 */
export function useCanvas(): CanvasContextValue {
  return useCanvasStore();
}
